import { useEffect, useState } from 'react';

const parseStoredValue = (item: string | null, defaultValue: any) => {
  if (item === null) {
    return defaultValue;
  }
  try {
    return JSON.parse(item);
  } catch (error) {
    // Fallback for legacy/plain string values (e.g., "en").
    return item;
  }
};

const serializeStoredValue = (value: any) => {
  if (typeof value === 'string') {
    return value;
  }
  return JSON.stringify(value);
};

export const useLocalStorage = (keyName: string, defaultValue: any) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(keyName);
      return parseStoredValue(item, defaultValue);
    } catch (error) {
      console.log(error);
      return defaultValue;
    }
  });

  useEffect(() => {
    const handleStorageChange = (event: any) => {
      if (event.key === keyName) {
        try {
          setStoredValue(parseStoredValue(event.newValue, defaultValue));
        } catch (error) {
          console.log(error);
        }
      }
    };

    // Listen for storage changes
    window.addEventListener('storage', handleStorageChange);

    // Cleanup
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [keyName]);

  const setValue = (newValue: any) => {
    try {
      setStoredValue(newValue);
      window.localStorage.setItem(keyName, serializeStoredValue(newValue));
    } catch (error) {
      console.log(error);
    }
  };

  return [storedValue, setValue];
};
